import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 30721 36637"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#343230}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="m2488 14159 1000 4022c2 8 5 17 6 25 635 3178 3449 5484 6688 5484h10355c3242 0 6054-2306 6689-5484 2-8 3-17 6-25l1002-4022H2488zm18049 10676H10182c-1836 0-3629-641-5049-1806-1418-1162-2397-2789-2759-4585l-1175-4720c-41-169-3-351 105-491 109-137 274-220 451-220h27210c177 0 343 83 451 220 109 140 149 322 104 491l-1174 4720c-360 1795-1341 3423-2758 4585-1420 1165-3214 1806-5051 1806z"
        className="fil0"
      />
      <path
        d="M1144 13013h28432v-1221H1144v1221zm29005 1146H571c-316 0-571-256-571-573v-2365c0-317 255-573 571-573h29578c316 0 572 256 572 573v2365c0 317-256 573-572 573zM12975 26057h4771v-1222h-4771v1222zm5344 1144h-5916c-317 0-573-257-573-572v-2367c0-316 256-572 573-572h5916c314 0 571 256 571 572v2367c0 315-257 572-571 572z"
        className="fil0"
      />
      <path
        d="M14158 35493h2404v-8292h-2404v8292zm2977 1144h-3549c-316 0-573-256-573-573v-9435c0-316 257-572 573-572h3549c316 0 573 256 573 572v9435c0 317-257 573-573 573zM14750 10648h1221V4122c0-969 788-1755 1755-1755 969 0 1756 786 1756 1755v610h1222v-610c0-1641-1337-2977-2978-2977s-2976 1336-2976 2977v6526zm1793 1144h-2366c-316 0-572-256-572-571V4122c0-2273 1849-4122 4121-4122s4122 1849 4122 4122v1183c0 317-257 573-573 573h-2365c-317 0-573-256-573-573V4122c0-336-273-611-611-611-336 0-611 275-611 611v7099c0 315-256 571-572 571zM21848 10648h2405V9427h-2405v1221zm2977 1144h-3550c-315 0-571-256-571-571V8854c0-316 256-572 571-572l3550-1c315 0 571 257 571 573v2367c0 315-256 571-571 571zM6468 10648h2404V9427H6468v1221zm2977 1144H5896c-316 0-573-256-573-571V8854c0-316 257-572 573-572l3549-1c316 0 573 257 573 573v2367c0 315-257 571-573 571z"
        className="fil0"
      />
      <path
        d="M17135 29567h-3549c-316 0-573-256-573-573 0-316 257-572 573-572h3549c316 0 573 257 573 572 0 317-257 574-573 573zM17135 31933h-3549c-316 0-573-256-573-572s257-572 573-572h3549c316 0 573 256 573 572s-257 572-573 572zM17135 34271h-3549c-316 0-573-256-573-572 0-317 257-573 573-573h3549c316 0 573 256 573 573 0 316-257 572-573 572z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
